import { render } from "./WCUserGreeter.vue?vue&type=template&id=3caae55c&scoped=true"
import script from "./WCUserGreeter.vue?vue&type=script&lang=js"
export * from "./WCUserGreeter.vue?vue&type=script&lang=js"

import "./WCUserGreeter.vue?vue&type=style&index=0&id=3caae55c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caae55c"]])

export default __exports__